import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { SystemMessage, SystemMessageService } from '../../../services/system-message.service';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-system-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './system-message.component.html',
  styleUrl: './system-message.component.scss'
})
export class SystemMessageComponent implements OnInit, OnDestroy {
  messages: SystemMessage[] = [];
  private sub?: Subscription;
  isAuthenticated = false;

  constructor(
    private systemMessageService: SystemMessageService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.sub = this.systemMessageService.message$.subscribe((msg) => {
      this.messages = this.isAuthenticated ? (msg || []) : [];
    });
    this.authService.currentUser$.subscribe((user) => {
      this.isAuthenticated = !!user;
      if (this.isAuthenticated) {
        this.systemMessageService.refresh();
      } else {
        this.messages = [];
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  close(id: number): void {
    this.systemMessageService.markSeen(id);
  }
}
